import Timeline from '@components/Timeline';

import { Requisition } from '@customTypes/requisition';
import { getTimelineStepsFromStatus } from './utils/orderStatusTimeline';

import './PatientDetailOrderStatusTimeline.scss';

interface PatientDetailOrderStatusTimelineProps {
  requisition: Requisition;
}

function PatientDetailOrderStatusTimeline({ requisition }: PatientDetailOrderStatusTimelineProps) {
  const steps = getTimelineStepsFromStatus(requisition);
  const externalStatus = requisition.external_status;

  return (
    <div className='patient-detail-order-status-timeline'>
      {externalStatus === 'CANCELED' && <h5 className='fs-4 fw-bold text-secondary canceled-status-title'>Canceled</h5>}
      {externalStatus === 'FAILED' && <h5 className='fs-4 fw-bold text-secondary failed-status-title'>Failed</h5>}
      <Timeline steps={steps} />
    </div>
  );
}

export default PatientDetailOrderStatusTimeline;
